import React, { createContext, useState, useContext } from "react";

import { useSelect } from "../hooks/useSelect";
import { usePhotoUploadsInDropzone } from "../../PhotoUploadCore/hooks";

export const Context = createContext();

export const EditPhotoUploadProvider = ({ children }) => {
    const { isChecked } = useSelect();
    const { getDataForUploads } = usePhotoUploadsInDropzone();

    const [editModalIsOpen, setEditIsModalOpen] = useState(false);
    const openEditModal = () => setEditIsModalOpen(true);
    const closeEditModal = () => {
        setEditIsModalOpen(false);
    };

    const getCheckedUploadIds = isChecked => {
        const ids = [];

        for (const id in isChecked) {
            if (!!isChecked[id]) ids.push(id);
        }

        return ids;
    };

    const uploadIds = getCheckedUploadIds(isChecked);

    const isBatchEditing = uploadIds.length > 1;

    const contextValues = {
        isBatchEditing,
        uploadIds: uploadIds || [],
        editModalIsOpen,
        uploads: getDataForUploads(uploadIds) || [],
        openEditModal,
        closeEditModal
    };

    return (
        <Context.Provider value={contextValues}>{children}</Context.Provider>
    );
};

export const useEditPhotoUpload = () => {
    const context = useContext(Context);

    if (context === undefined) {
        throw new Error(
            "useEditPhotoUpload must be used within an EditPhotoUploadProvider"
        );
    }

    return context;
};
